module.exports = __webpack_public_path__ + "static/media/garmin.b1002b2b.png";